// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initContractContentTool = function () {
    (function (_super) {
        coffeeExtends(ContractContentTool, _super);
        function ContractContentTool() {
            return ContractContentTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(ContractContentTool, 'contractcontent');
        ContractContentTool.label = 'Insert Contract Content';
        ContractContentTool.icon = 'contractcontent';
        ContractContentTool.tagName = 'cnt';
        ContractContentTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const ccHtml = `<${ContractContentTool.tagName} contenteditable="false">CONTRACT CONTENT</${
                ContractContentTool.tagName
            }>`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String(' ', true),
                ccHtml,
                new window.HTMLString.String(' ', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 12, cursor + 12);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_ContractContentTool',
                transform: true
            });
            callback(true);
        };
        return ContractContentTool;
    })(ContentTools.Tools.LineBreak);
};
